<template>
	<div
		class="engage-loader"
		:class="{
			'engage-loader--overlay': overlay,
			'engage-loader--inline': inline,
			'engage-loader--compact': compact,
			'engage-loader--violet': violet,
		}"
		aria-busy="true"
		:aria-live="ariaLive"
		role="status"
	>
		<div class="engage-loader__spinner" />
		<h3 class="engage-loader__text">
			{{ text }}
		</h3>
	</div>
</template>

<script>
/**
 * Engage-style loading indicator shared across Engage and Settings screens.
 */
export default {
	name: 'EngageLoader',

	props: {
		ariaLive: {
			type: String,
			default: 'polite',
		},

		inline: {
			type: Boolean,
			default: false,
		},

		compact: {
			type: Boolean,
			default: false,
		},

		violet: {
			type: Boolean,
			default: false,
		},

		overlay: {
			type: Boolean,
			default: false,
		},

		text: {
			type: String,
			default: 'Loading...',
		},
	},
}
</script>
